var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStatesNoUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.999 190.5C187.499 190.5 211.499 190.5 202.499 109C197.604 64.6685 172.078 33.5 129 33.5C85.9213 33.5 56.4993 55 56.4994 112C59.4994 173.5 113.921 190.5 156.999 190.5ZM85.7899 61.828C88.0103 64.5437 92.8923 64.2252 96.6941 61.1167C100.496 58.0082 101.778 53.2869 99.5578 50.5713C97.3374 47.8556 92.4554 48.1741 88.6536 51.2826C84.8517 54.391 83.5696 59.1124 85.7899 61.828Z",
    fill: "url(#paint0_linear_18906_43943)",
    fillOpacity: 0.07
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.797 104.064H117.202C112.936 104.064 109.478 107.522 109.478 111.788V165.851H145.521V111.788C145.521 107.522 142.063 104.064 137.797 104.064ZM117.202 96.3408C108.671 96.3408 101.755 103.257 101.755 111.788V168.426C101.755 171.27 104.06 173.575 106.904 173.575H148.095C150.939 173.575 153.244 171.27 153.244 168.426V111.788C153.244 103.257 146.328 96.3408 137.797 96.3408H117.202Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.499 83.4681C134.609 83.4681 140.372 77.7049 140.372 70.5957C140.372 63.4865 134.609 57.7234 127.499 57.7234C120.39 57.7234 114.627 63.4865 114.627 70.5957C114.627 77.7049 120.39 83.4681 127.499 83.4681ZM127.499 91.1915C138.874 91.1915 148.095 81.9705 148.095 70.5957C148.095 59.221 138.874 50 127.499 50C116.125 50 106.904 59.221 106.904 70.5957C106.904 81.9705 116.125 91.1915 127.499 91.1915Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.691 93.7659C172.957 93.7659 176.415 90.308 176.415 86.0425C176.415 81.777 172.957 78.3191 168.691 78.3191C164.426 78.3191 160.968 81.777 160.968 86.0425C160.968 90.308 164.426 93.7659 168.691 93.7659ZM168.691 101.489C177.222 101.489 184.138 94.5735 184.138 86.0425C184.138 77.5115 177.222 70.5957 168.691 70.5957C160.16 70.5957 153.245 77.5115 153.245 86.0425C153.245 94.5735 160.16 101.489 168.691 101.489Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3081 93.7659C90.5737 93.7659 94.0315 90.308 94.0315 86.0425C94.0315 81.777 90.5737 78.3191 86.3081 78.3191C82.0426 78.3191 78.5847 81.777 78.5847 86.0425C78.5847 90.308 82.0426 93.7659 86.3081 93.7659ZM86.3081 101.489C94.8392 101.489 101.755 94.5735 101.755 86.0425C101.755 77.5115 94.8392 70.5957 86.3081 70.5957C77.7771 70.5957 70.8613 77.5115 70.8613 86.0425C70.8613 94.5735 77.7771 101.489 86.3081 101.489Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.106 111.787C157.106 109.655 158.835 107.926 160.968 107.926H173.84C181.66 107.926 188 114.265 188 122.085V167.139H160.968C158.835 167.139 157.106 165.41 157.106 163.277C157.106 161.144 158.835 159.415 160.968 159.415H180.276V122.085C180.276 118.531 177.395 115.649 173.84 115.649H160.968C158.835 115.649 157.106 113.92 157.106 111.787Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8931 111.787C97.8931 109.655 96.1641 107.926 94.0314 107.926H81.159C73.3389 107.926 66.9994 114.265 66.9994 122.085V167.139H94.0314C96.1641 167.139 97.8931 165.41 97.8931 163.277C97.8931 161.144 96.1641 159.415 94.0314 159.415H74.7229V122.085C74.7229 118.531 77.6044 115.649 81.159 115.649H94.0314C96.1641 115.649 97.8931 113.92 97.8931 111.787Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9995 150C44.9578 112 70.4995 111 84.4995 112C153 116.893 184.999 138.5 198.5 146.5C235.5 168.426 243.5 215.737 157.5 211.5C55.9995 206.5 38.4995 174 40.9995 150Z",
    fill: "url(#paint1_linear_18906_43943)",
    fillOpacity: 0.15
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.736 30.0538C163.236 20.0538 172.736 27.5538 175.236 30.0538C185.736 41.0538 189.736 58.0538 172.236 57.5538C154.736 57.0538 128.236 40.0538 145.736 30.0538Z",
    fill: "url(#paint2_linear_18906_43943)",
    fillOpacity: 0.15
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.981,
    cy: 135.238,
    rx: 9.75579,
    ry: 13.6581,
    transform: "rotate(20.87 28.981 135.238)",
    fill: "url(#paint3_linear_18906_43943)",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.1377,
    cy: 128.284,
    rx: 4.97707,
    ry: 6.9679,
    transform: "rotate(20.87 12.1377 128.284)",
    fill: "url(#paint4_linear_18906_43943)",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18906_43943",
    x1: 125.188,
    y1: 182.185,
    x2: 46.9713,
    y2: 40.8043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18906_43943",
    x1: 126.316,
    y1: 206.472,
    x2: 95.514,
    y2: 97.5966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18906_43943",
    x1: 160.544,
    y1: 55.84,
    x2: 147.735,
    y2: 22.4539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18906_43943",
    x1: 28.286,
    y1: 147.449,
    x2: 12.9881,
    y2: 126.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18906_43943",
    x1: 11.7831,
    y1: 134.514,
    x2: 3.97867,
    y2: 123.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatesNoUsers);
export default __webpack_public_path__ + "static/media/emptyStatesNoUsers.25905175.svg";
export { ForwardRef as ReactComponent };